import React from "react";
import Sidebar from "../../components/client/Sidebar";
import Header from "../../components/client/Header";
import { Outlet } from "react-router";

const ClientLayout = () => {
  return (
    <div className="w-screen h-screen flex bg-[#edf7fd]">
      <div className="hidden lg:block">
        <Sidebar />
      </div>
      <div className="overflow-y-auto scrollbar-hide w-full h-full">
        <div className="sticky top-0 z-30">
          <Header />
        </div>
        <div className="p-3 lg:p-10">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ClientLayout;
